module.exports = __webpack_public_path__ + "img/page1-new.15a71365.png";